import { Link } from "react-router-dom";
import { Instagram, ArrowUpRight, Clock } from "lucide-react";
import Logo from "@/components/Logo";

const INSTAGRAM_URL =
  "https://www.instagram.com/pristyncleaning?igsh=YzgycDRhcWhoYnZt&utm_source=qr";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-black text-white">
      <div className="pc-container pt-20 pb-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2 font-display text-2xl font-extrabold">
              <Logo variant="dark" size={48} />
              Pristyn<span className="text-[var(--pc-green)]">.</span>
            </div>
            <p className="mt-4 max-w-sm text-base text-white/60">
              Toronto's premium cleaning company. Built for people who notice
              the details.
            </p>
            <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-white/15 px-3 py-1.5 text-xs text-white/70">
              <Clock size={14} className="text-[var(--pc-green)]" />
              Mon–Sat 8AM–7PM · <span className="text-red-300">Closed Sundays</span>
            </div>
            <div className="mt-6 flex gap-3">
              <a
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-social-instagram"
                className="inline-flex items-center gap-2 rounded-full border border-white/15 px-4 py-2 text-sm transition hover:border-[var(--pc-green)] hover:bg-[var(--pc-green)] hover:text-black"
                aria-label="Follow on Instagram"
              >
                <Instagram size={16} /> @pristyncleaning
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="eyebrow text-white/40">Services</div>
            <ul className="mt-4 space-y-2 text-base">
              <li>Home Cleaning</li>
              <li>Office Cleaning</li>
              <li>Commercial Cleaning</li>
              <li>Construction Cleanup</li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="eyebrow text-white/40">Company</div>
            <ul className="mt-4 space-y-2 text-base">
              <li>
                <button onClick={() => document.getElementById("services")?.scrollIntoView({ behavior: "smooth" })} className="hover:text-[var(--pc-green)]">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById("book")?.scrollIntoView({ behavior: "smooth" })} className="hover:text-[var(--pc-green)]">
                  Book
                </button>
              </li>
              <li>
                <button onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })} className="hover:text-[var(--pc-green)]">
                  Contact
                </button>
              </li>
              <li>
                <Link to="/admin/login" data-testid="footer-admin-link" className="inline-flex items-center gap-1 hover:text-[var(--pc-green)]">
                  Admin <ArrowUpRight size={14} />
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="eyebrow text-white/40">Contact</div>
            <ul className="mt-4 space-y-2 text-base">
              <li>
                <a href="tel:6476099266" className="hover:text-[var(--pc-green)]">
                  647-609-9266
                </a>
              </li>
              <li>
                <a href="mailto:pristyncleaning@gmail.com" className="hover:text-[var(--pc-green)]">
                  pristyncleaning@gmail.com
                </a>
              </li>
              <li className="text-white/60">Toronto, ON</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 text-xs text-white/40 md:flex-row md:items-center">
          <div>© {new Date().getFullYear()} Pristyn Cleaning. All rights reserved.</div>
          <div className="uppercase tracking-[0.25em]">Made in Toronto</div>
        </div>
      </div>
    </footer>
  );
}
